"use strict";
/**
 * Generic Aurus Error Class resolver
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AurusError = void 0;
/**
 * AurusError Generic captured error.
 */
class AurusError extends Error {
    // istanbul ignore next
    constructor(code, message) {
        super(`AURUS${code}`) /* istanbul ignore next: TODO: reporter is failing */;
        this.code = code;
        this._message = message;
        Object.setPrototypeOf(this, AurusError.prototype);
    }
    getMessage() {
        return this._message;
    }
    getStatusCode() {
        return 400;
    }
}
exports.AurusError = AurusError;
